import { getNegotiateCopyText, isChatSubmitKey, mapNegotiateMessage, MessageNegotiate } from 'src/app/core/services/negotiation-chat';
export { MessageNegotiate, MergeFieldHistory } from 'src/app/core/services/negotiation-chat';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { MatDialog } from '@angular/material';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ViewDocumentReferenceComponent } from 'src/app/shared/components/view-document-reference/view-document-reference.component';
import { DocumentService } from 'src/app/core/services/document.service';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import {
  EnumApproverStatus,
  EnumContractDetailType,
  EnumContractEnterpriseStatus,
  EnumContractStatus,
  EnumContractUserRole,
  EnumContractUserStatus,
  EnumSignMethod
} from 'src/app/core/constants/contract';
import {EnterpriseService} from 'src/app/core/services/enterprise.service';
import {ContractService} from '../../../../../../core/services/contract.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {NzConfigService} from 'ng-zorro-antd/core';
import {MatDialogRef} from '@angular/material/dialog';
import {ConfirmForwardComponent} from "../../../../../../shared/components/confirm-forward/confirm-forward.component";
import { TimestampListDialogComponent } from '../timestamp-list-dialog/timestamp-list-dialog.component';
import { EnumRoleUser } from "src/app/core/constants/common";
import {ViewContractComponent} from "../contract-digitization/view-contract/view-contract.component";
import {DigitalContractService} from "../../../../../../core/services/digital-contract.service";
import {BlockUI, NgBlockUI} from "ng-block-ui";
import { finalize, take } from 'rxjs/operators';
import { ViewFilePdfImgComponent } from 'src/app/shared/components/view-file-pdf-img/view-file-pdf-img.component';
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';

// -------------------------------BEGIN - Interface***-------------------------------//

interface EnterpriseElement {
  enterpriseId: number;
  order: number;
  email: string;
  enterpriseName: string;
  phoneNumber: number;
  status: boolean;
  isSameEntepriseCurrentLogin: boolean;
}

interface ViewUserElement {
  order: number;
  userId: string;
  enterpriseId: number;
  userName: string;
  userEmail: string;
  status: number;
  signingTime: Date;
  rejectionTime: Date;
}

// ant design
interface ParentItemData {
  key: number;
  name: string;
  platform: string;
  version: string;
  upgradeNum: number | string;
  creator: string;
  createdAt: string;
  expand: boolean;
}

interface ChildrenItemData {
  key: number;
  name: string;
  date: string;
  upgradeNum: string;
}

export interface TreeNodeInterface {
  key: number;
  order: string;
  name?: string;
  contact?: string;
  status?: string;
  role?: string;
  comment?: string;
  time?: string;
  certificateNo?: string;
  certificateNoNew?: string;
  showNoFlowNotification: boolean;
  establishSignNoLogin?: boolean;
  isSignedAnonymous?: boolean;
  type: string;
  level?: number;
  expand?: boolean;
  children?: TreeNodeInterface[];
  parent?: TreeNodeInterface;
  taxCode?: string;
  contractUserId?: string;
  isCreatedSide?: string;
  isSetUpSignFlow?: boolean;
  isSetUpSignFlowCreatedSide?: boolean;
}

// -------------------------------END - Interface***-------------------------------//

@Component({
  selector: 'app-panel-document-view',
  templateUrl: './panel-document-view.component.html',
  styleUrls: ['./panel-document-view.component.scss']
})
export class PanelDocumentViewComponent implements OnInit, OnDestroy, AfterViewInit {

  // -------------------------------BEGIN - Available***-------------------------------//

  // DRAFT(0),
  // WAIT_1(1),
  // SINGED_1(2),
  // REJECT_1(3),
  // WAIT_2(4),
  // SINGED_2(5),
  // REJECT_2(6);
  // Finish (7); ?
  // 0 - Nháp
  // 1- Chờ ký bên lập
  // 2 - Đã ký bên lập
  // 3 - Từ chối bên lập
  // 4 - Chờ ký bên nhận
  // 5 - Ký bên nhận
  // 6 - Từ chối bên nhận
  // 7 - HOÀN THÀNH
  // 8 - Mới gởi qua bên nhận
  public isShowReferencePdf: BehaviorSubject<boolean>;
  selectedDocumentTypeParent: { id: string, name: string, code?: string, filePath?: string };
  @Input() documentTypeEnterprise: any;
  @Input() forceShowCustomerSignInfo = false;
  // true khi API detail dang chay: cac o text thong tin chua du lieu hien skeleton inline
  // (phan info co the duoc prefill tu row bang list -> false ngay, khong skeleton)
  @Input() isLoadingInfo = false;
  // true khi API list-user-sign dang chay: hang bang "Các bên ký kết" hien skeleton
  @Input() isLoadingParties = false;
  @BlockUI() blockUI: NgBlockUI;
  checkUSerCreateContract: boolean = false;
  documentReference = [];
  listOriginalContact:any[] = [];
  documentParentName = '';
  isEssential: boolean;
  document: any = {
    id: '',
    code: '',
    name: '',
    parentId: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    documentTypeEnterpriseId: '',
    customerId: '',
    status: 0,
    filePath: '',
    description: '',
    assignUserId: 0,
    submitedTo: 0,
    submitedToA: '',
    submitedTime: '',
    typeId: null,
    isDeleted: true,
    jsonData: '',
    email: '',
    phone: '',
    createdBy: '',
    createdTime: '',
    updatedBy: '',
    updatedTime: '',
    finishDate: '',
    salt: '',
    documentTypeContent: '',
    expiredDate: '',
    contractAttachments: [],
    newUploadContractAttachments: [],
    isSended: false,
    serviceType: '',
    cancelReason: '',
    cancelTime: null,
    cancelUserFullName: '',
    processDate: '',
    isConfirmBCT: null,
    bctConfirmStatus: null,
    bctConfirmMessage: null,
    verifyPrice: 0,
    verifyPriceDetails: [],
    mainContractAttachments: [],
    contractAppendixDTOS: [],
  };
  creatorSide = false
  pdfSrc = '';
  isSetUpSignFlow = false;
  creatorSignInfo: any;
  isOtpLimited:boolean = false;
  creatorSubmitInfo: any;
  roleUser = EnumContractUserRole;
  valueSelectedUserRole: string = (this.roleUser.APPROVE + '');
  public isPanelDocumentViewSuccess = new Subject();
  /**
   * History of reciver
   */
  receiverFromCreatorInfo: any;

  receiverSubmitInfo: any;

  receiverInfo: any;
  isCustomer: boolean;
  isNegotiate: boolean = false
  isContractStandardized: boolean = false
  @Output() navigate: any = new EventEmitter<boolean>();
  @Input() documentInfo: any;
  @Input() showIconAttachment: boolean = false
  @ViewChild('contentEmptyTable', { static: false }) contentEmptyTable: TemplateRef<any>; // Set no display No_data on Nz-Table
  /**
   * Check document side create or reciver
   */
  userType: number;
  expanded = [];
  expandedUser = [];
  // enum
  enumContractStatus = EnumContractStatus;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  enumContractUserRole = EnumContractUserRole;
  enumContractUserStatus = EnumContractUserStatus;
  enumApproverStatus = EnumApproverStatus;
  enumContractDetailType = EnumContractDetailType;
  enumSignMethod = EnumSignMethod;

  documentId = '';
  isSetSignFlow = false;
  isTakenSideView = false;
  checkUrlDigital = false;

  inputUserValue: string;
  contractView = {
    contractName: '',
    id: [],
    filesName: [],
    listFileSize: [],
    idDocument:'',
    checkMan:2,
    attachments: []
  };
  isLoadUserSign = false;
  isChangeRoleUser: boolean = false;

  // -------------------------------***END - Available***-------------------------------//
  listOfMapData = [];
  listOfMapDataCustomer = [];
  listDataApprover = [];
  listOfInformationSignedData = [];
  listOfMapInitialData = [];
  mapOfExpandedData: { [key: string]: any } = {};
  mapOfInformationSignedData: { [key: string]: any } = {};
  mapOfInitialData: { [key: string]: any } = {};
  enterpriseId: string;
  public listEnterpriseSign = [];
  public listOfDataUserSign = [];
  public listOfDataUserForward = [];
  isAllContractShareDone = true;
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  private isFormChanging: boolean;
  filteredUserOptions = [];
  isValidNoUserExist = false;
  isValidExistingSigning = false;
  public currentListUserSign = [];
  public listInitial = [];
  private userId: string;
  private dialogRefDocumentReference: MatDialogRef<ViewDocumentReferenceComponent, any>;
  cecaEnable: boolean;
  userLoginId: string;
  isShowRetry = false;
  expiredMoit: boolean = false;
  isNotAttestedUser: boolean = false;
  goFrom: any;
  flagCopy: boolean = false;
  entType: any = localStorage.getItem('entType');
  checkMohaDigital = false;
  @Input() isDocumentMoha: boolean = false

  constructor(
    private commonService: CommonService,
    private customerService: CustomerService,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private documentService: DocumentService,
    private toastr: ToastrService,
    private message: Message,
    private digitalContractService: DigitalContractService,
    private documentTypeService: DocumentTypeService,
    public autoUserService: AutoUserService,
    private enterpriseService: EnterpriseService,
    private router: ActivatedRoute,
    private route: Router,
    private contractService: ContractService,
    private nzConfigService: NzConfigService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    public createContractMohaService: CreateContractMohaService,
    private documentMohaService: DocumentMohaService
  ) {
    this.userType = Number(localStorage.getItem('userType'));
    this.documentId = this.router.snapshot.paramMap.get('id');
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';
    this.userLoginId = localStorage.getItem('userId');
    this.isShowReferencePdf = new BehaviorSubject<boolean>(false);
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.goFrom = this.router.snapshot.queryParams.goFrom
    this.flagCopy = this.router.snapshot.queryParams.flagCopy || false
  }

  collapse(array, data, $event: boolean): void {
    if ($event === false) {
      if (data.children) {
        data.children.forEach(d => {
          const target = array.find(a => a.key === d.key)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }

  convertTreeToList(root) {
    const stack = [];
    const array = [];
    const hashMap = {};
    stack.push({...root, level: 0, expand: false});

    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({...node.children[i], level: node.level! + 1, expand: false, parent: node});
        }
      }
    }
    return array;
  }

  visitNode(node: TreeNodeInterface, hashMap: { [key: string]: boolean }, array: TreeNodeInterface[]): void {
    if (!hashMap[node.key]) {
      hashMap[node.key] = true;
      array.push(node);
    }
  }

  /**
   * Init component
   */
  ngOnInit() {
    this.notificationService.subscribeErrorService();
    // this.getListEnterpriseUserSignByDocumentId();
    // this.getListEnterpriseUserSignByDocumentId1();
    this.checkUrl();
  }

  ngOnDestroy() {
    if(this.intervalChat){
      clearInterval(this.intervalChat)
    }
    this.notificationService.subscribeErrorService();
  }

  ngAfterViewInit() {
    if (this.documentInfo) {
      this.document = this.documentInfo;
    }

    // Set empty when nz-table has NO-DATA
    this.nzConfigService.set('empty', {nzDefaultEmptyContent: this.contentEmptyTable});
    this.scrollToBottom()
  }

  onSaveSignFlow() {
    if (!this.validateErrorSetUser(null)) {
      if(!this.checkValidateUserSign()) {
        this.sortOrderApproveSign();
        const data = {
          ...[],
          id: this.document.id,
          userSign: this.listOfDataUserSign
        };

        this.contractService.updateUserSignReceive(data)
          .subscribe(result => {
            this.toastr.success(this.commonService.format(this.message.getMessage('messages.setup_signing_flow_receiver')));
            this.isPanelDocumentViewSuccess.next({} );
          });
      }
    }
  }

  // -- Nghiep vu set User trong luong ky noi bo ---
  // -----------------------------------------------

  onChangeOrderApproveSign() {
    this.setFormChanging(true);
  }

  checkValidateUserSign() {
    let RECORD_USER_APPROVE = [...this.listOfDataUserSign.filter(item => item.role === '2').sort((a, b) => {
      return a.order - b.order;
    })];
    let RECORD_USER_SIGN = [...this.listOfDataUserSign.filter(item => item.role === '1')];

    if(this.listOfDataUserSign.every((data) => data.role === '2')) {
      return this.toastr.error(this.commonService.format(this.message.getMessage('messages.error_no_user_sign')));
    }

    if(this.listOfDataUserSign.length > 1) {
      if(RECORD_USER_SIGN[0].order < RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order) {
        return this.toastr.error(this.commonService.format(this.message.getMessage('messages.error_order_user_sign_greater_user_approve')));
      }

      if(RECORD_USER_SIGN[0].order == RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order) {
        return this.toastr.error(this.commonService.format(this.message.getMessage('messages.error_order_user_sign_equal_user_approve')));
      }
    }
    return false;
  }

checkUrl() {
   if(this.route.url.includes('view-document-moha-digital')){
     this.checkUrlDigital = true;
   }
}

  sortOrderApproveSign() {
    let newOrder = 0;
    let RECORD_USER_APPROVE = [...this.listOfDataUserSign.filter(item => item.role === '2')];
    let RECORD_USER_SIGN = [...this.listOfDataUserSign.filter(item => item.role === '1')];

    if(RECORD_USER_APPROVE.length) {
      RECORD_USER_APPROVE = RECORD_USER_APPROVE.sort((a, b) => {
        return a.order - b.order;
      });

      RECORD_USER_APPROVE = RECORD_USER_APPROVE.map((item, index) => {
        if(index === 0) {
          newOrder = 1;
          return {
            ...item,
            order: 1
          }
        } else {
          if(item.order !== RECORD_USER_APPROVE[index -1].order) {
            newOrder++;
          }
          return {
            ...item,
            order: newOrder
          }
        }
      });

      RECORD_USER_SIGN = RECORD_USER_SIGN.map((item) => ({
        ...item,
        order: RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1
      }))
    }

    const RECORD_USER_PERFORM_SIGN = RECORD_USER_APPROVE.concat(RECORD_USER_SIGN);

    this.listOfDataUserSign = RECORD_USER_PERFORM_SIGN;
  }

  changeRoleUserSign(value: any, data: any) {
    if(value == 1) {
      this.isChangeRoleUser = true;
      this.listOfDataUserSign = [...this.listOfDataUserSign.filter((item) => item.userId !== data.userId)];
      this.listOfDataUserSign = [...this.listOfDataUserSign.map((item) => ({
        ...item,
        role: this.roleUser.APPROVE + ''
      }))];
      this.listOfDataUserSign.push({
        ...data,
        order: this.listOfDataUserSign[this.listOfDataUserSign.length - 1].order + 1,
        role: this.roleUser.SIGN + ''
      });
    }
  }

  onChangeUserSignSearch(event): void {
    if (this.inputUserValue.trim().length > 0) {
      this.isLoadUserSign = true;
      this.autoUserService.fetchAuto(event)
        .then(result => {
          this.filteredUserOptions = result;
        }).finally(() => {
        this.isLoadUserSign = false;
      });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if (!this.checkExistedUser(model.id, model.name, model.email)) {
        // Re-set all old members to "APPROVE" role
        this.listOfDataUserSign = this.listOfDataUserSign.map((item, index) => {
          return {
            ...item,
            role: this.isChangeRoleUser ? item.role : this.roleUser.APPROVE + ''
          };
        });

        const listOfDataUserSignNewOrder = this.listOfDataUserSign.sort((a, b) => {
          return a.order - b.order;
        })
        this.listOfDataUserSign = [...listOfDataUserSignNewOrder];

        // order before push data
        const orderUserSign = this.listOfDataUserSign.length ? this.listOfDataUserSign[this.listOfDataUserSign.length - 1].order + 1 : 1;
        let RECORD_USER_APPROVE = [...this.listOfDataUserSign.filter(item => item.role === '2')];
        RECORD_USER_APPROVE = RECORD_USER_APPROVE.sort((a, b) => {
          return a.order - b.order;
        });
        const orderUserApprove = RECORD_USER_APPROVE.length ? RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1 : -1;

        this.listOfDataUserSign = [
          ...this.listOfDataUserSign,
          {
            order: this.isChangeRoleUser ? (this.listOfDataUserSign.every((data) => data.role === '2') ? orderUserSign : orderUserApprove) : orderUserSign,
            userId: model.id,
            enterpriseSignId: this.enterpriseId,
            name: model.name,
            email: model.email,
            role: this.isChangeRoleUser ? (this.listOfDataUserSign.every((data) => data.role === '2') ? this.roleUser.SIGN + '' : this.roleUser.APPROVE + '') : this.roleUser.SIGN + '',
            phone: model.phone,
            isCreatedSide: false
          }
        ];

        // remove and repush userSign => userUser order last
        if(this.listOfDataUserSign.length > 1) {
          const dataUserSign = this.listOfDataUserSign.find((item) => item.role === '1');
          this.listOfDataUserSign = [...this.listOfDataUserSign.filter((item) => item.role !== '1')];
          this.listOfDataUserSign.push({
            ...dataUserSign,
            order: this.listOfDataUserSign[this.listOfDataUserSign.length - 1].order + 1
          });
        }

        this.inputUserValue = '';
        this.isValidNoUserExist = false;
      }
    }
  }
  private checkmatched(listFileName: string[], name: string) {
    const filenameSplit = name.split('.')
    const type = filenameSplit.pop();
    const fileName = filenameSplit.join('.');
    let fileNameConverted = fileName + '.' + type;
    let k = 1;
    if (listFileName.length > 0) {
      while (listFileName.includes(fileNameConverted)) {
        fileNameConverted = fileName + '(' + k + ').' + type;
        k++;
      }
    }


    return fileNameConverted;
  }
  viewContract(ala,data?) {
    if(ala.typeId == 2){
      this.blockUI.start();
      this.digitalContractService.getContractById(ala.id).pipe(finalize(()=> this.blockUI.stop)).subscribe(async res => {
        if (res.data && res.success) {
          this.contractView.contractName = res.data.code + ' - ' + res.data.name;
          const attachments = res.data.contractAttachments;
          if (attachments.length > 0) {
            this.blockUI.start();
            const nameList = [];
            const idList = [];
            const listFileSize = [];

            for (let file of attachments) {
              nameList.push(this.checkmatched(nameList, file.fileName));
              idList.push(file.id)
              listFileSize.push(file.fileSize)
              if (idList.length === attachments.length) {
                this.blockUI.stop();
              }
            }
            this.contractView.filesName = nameList;
            this.contractView.id = idList;
            this.contractView.listFileSize = listFileSize;
            this.isShowReferencePdf.next(true);
            this.contractView.idDocument = ala.id;
            if(data){
              this.contractView.checkMan = data;
            }
            this.contractView.attachments = attachments
            const dialog = this.dialog.open(ViewContractComponent, {
              data: this.contractView,
              width: '90%',
              minHeight: '90%'
            });
            dialog.afterClosed().subscribe(res => {
              this.isShowReferencePdf.next(false);
            })
            // this.blockUI.stop();

          }
        } else {
          this.toastr.error(res.message);
        }
      });
    }
    else {
      this.viewDocumentReference(ala);
    }

  }
  onClickDeleteElementRecordUser(data: any): void {
    this.listOfDataUserSign = this.listOfDataUserSign.filter(d => d.userId !== data.userId);
    // update role of last user to SIGN
    // if (this.listOfDataUserSign.length > 0) {
    //   this.listOfDataUserSign[this.listOfDataUserSign.length - 1].role = this.roleUser.SIGN + '';
    // }
    if(this.listOfDataUserSign.length === 0) {
      this.isChangeRoleUser = false;
    }
    this.setFormChanging(true);
    this.validateErrorSetUser();
  }

  // validate form User
  private validateErrorSetUser(model?) {
    // Kiểm tra trong list ko chua User nào?
    if (this.listOfDataUserSign.length == 0) {
      this.isValidNoUserExist = true;
      return true;
    } else {
      this.isValidNoUserExist = false;
    }
    return false;
  }

  checkExistedUser(id: string, fullname: string, email: string) {
    const existedList = this.listOfDataUserSign.filter((e) => {
      return e.userId == id;
    });

    if (existedList.length > 0) {
      this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate'), [fullname + ' - ' + email]));
      return true;
    } else {
      return false;
    }
  }

  onChangeUserRole(): void {
    this.validateErrorSetUser();
  }

  // -- End of Nghiep vu set User trong luong ky noi bo ---
  // ------------------------------------------------------


  /**
   * View document reference.
   * @param id The document id.
   */
  public viewDocumentReference(item) {
    this.isShowReferencePdf.next(true);
    const {id, filePath} = item;
    const data: ViewDocumentReferenceDto = {
      mainContractId: this.document.id,
      referenceContractId: id,
      pdfFilePath: filePath
    };
    if (id) {
      this.dialogRefDocumentReference = this.dialog.open(ViewDocumentReferenceComponent, {
        width: '1000px',
        data,
      });
    } else {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.not_documentId'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.not_documentId'));
      }
    }

    this.dialogRefDocumentReference.afterClosed().subscribe(() => {
      this.isShowReferencePdf.next(false);
    });
  }


  public getDocumentById(data, takeInfo: any, serviceType = null, enterpriseSign = [], userSign = [], userApproves = [], initial = [], enterpriseSignIdInFlow: any, isSetUpSignFlow? :any, userSignAll  = [], creatorSide?: any, expiredMoit?: boolean, isContractStandardized?: boolean) {
    this.document = data;
    this.isNegotiate = data.negotiate || false
    this.isContractStandardized = isContractStandardized;
    if (this.document.contractOriginalDTO) {
      this.listOriginalContact.push(this.document.contractOriginalDTO);
    }
    if(this.goFrom == 'share'){
      this.isNegotiate = false
    }
    if(this.isNegotiate){
      this.documentService.getApparamInfo({code: 'negotiate_max_file'}).subscribe(res => {
        if(res.data.value){
          this.maxNumberFile = res.data.value
        }
      })
      this.documentService.getApparamInfo({code: 'negotiate_max_capacity'}).subscribe(res => {
        if(res.data.value){
          this.maxSize = res.data.value
        }
      })
      this.getHistoryChat(true)
      if(this.intervalChat){
        clearInterval(this.intervalChat)
      }
      this.intervalChat = setInterval(()=>{
        this.getHistoryChat()
      },10000)
      if(this.router.snapshot.queryParams.goFrom == 'enterprise'){
        const userId = localStorage.getItem('userId')
        if(userSign.map(item => item.userId).includes(userId) || this.document.createdBy === userId){
          this.isComment = true
        } else {
          this.isComment = false
        }
      }
    }
    this.expiredMoit = expiredMoit
    this.isShowRetry = this.document.createdBy === localStorage.getItem('userId');
    this.creatorSide = creatorSide;
    this.listOfDataUserForward = data.contractShares;
    for (let item of this.listOfDataUserForward) {
      if (item.status !== 'SUCCESS') {
        this.isAllContractShareDone = false;
        break;
      }
    }

    if (serviceType) {
      this.document.serviceType = serviceType.name;
      this.isEssential = serviceType.type === 2 ? true : false;
      this.isOtpLimited = serviceType.isOtpLimited;
    }
    if(enterpriseSign) {
      let arrayEnterpriseCreateContract;
      let arrayUserCreateContract;
      arrayEnterpriseCreateContract = enterpriseSign.filter((data) => data.enterpriseId == this.enterpriseId && data.isCreatedSide == true);
      arrayUserCreateContract = userSign.filter((data) => data.userId == this.userLoginId && data.isCreatedSide == true);
      if(arrayEnterpriseCreateContract.length || arrayUserCreateContract.length) {
        this.checkUSerCreateContract = true;
      } else {
        this.checkUSerCreateContract = false; // check xem cos thang lap trung hjay k sua o day
      }
      if(data.isHaveNoCreatedSide && data.isHaveNoCreatedSide != null) {
        this.checkUSerCreateContract = true;
      }
    }
    this.listEnterpriseSign = enterpriseSign;
    if(this.isIos()) {
      this.listEnterpriseSign.forEach(async (item) => {
        if(!item.isCreatedSide) {
          const customerId = this.decodeId(item.customerId)
          const payload = {
            id: customerId,
            isCreatedSide: item.isCreatedSide
          };
          const res = await this.documentService.retrieveSignLink(this.documentId, payload).toPromise();
          item.signLink = res.data;
        }
      })
    }
    this.listOfDataUserSign = userSign.filter(item => item.enterpriseSignId === this.enterpriseId); // Laays thang lap hd (hien tai dang la thang dang nhau (0 co)
    // kiểm tra xem nó có được thêm luồng ký nội bộ hay không
    //
    const currentEnterpriseProcess = enterpriseSign.filter(item => item.enterpriseId === this.enterpriseId
      && (item.status === this.enumContractEnterpriseStatus.PROCESSING || item.status === this.enumContractEnterpriseStatus.WAIT_SETUP_FLOW));
    this.isSetSignFlow = (userSign.length === 0 && currentEnterpriseProcess.length > 0 && this.document.status == this.enumContractStatus.PROCESSING);
    // map data for signing flow
    if (enterpriseSign) {
      const arr = [];
      // Check whether this enterprise create the document ?
      const isCreatedEnterprise = false;
      let signMetadata: any;
     const isSetUpSignFlowNew = enterpriseSign.filter(item => { // khi lap hd co thiet lap luong kly hay k
       return item.isSetUpSignFlow; // cos list co daoan h nghiep
     })
      if(isSetUpSignFlowNew.length == 0 || !this.checkUSerCreateContract) {
        this.isSetUpSignFlow = false
        for (let index = 0; index < enterpriseSign.length; index++) {
          let childrenItems = [];
          if (enterpriseSign[index].signMetadata) {
            signMetadata = JSON.parse(enterpriseSign[index].signMetadata);
          }

          // Kiểm tra enterprise để bind dữ liệu người dùng cho phù hợp
          if ( enterpriseSign[index].enterpriseId &&
            (enterpriseSign[index].enterpriseId == enterpriseSignIdInFlow ||
            (enterpriseSignIdInFlow == null && enterpriseSign[index].customerId != undefined && enterpriseSign[index].enterpriseId == this.enterpriseId))) {
            if (enterpriseSign[index].isSignedAnonymous == false) {    //ky k dang nhap       // Nếu đơn vị chưa hoặc không thực hiện ký qua email, có đăng nhập tài khoản hệ thống
              if (userSign && userSign.length > 0) {
                  childrenItems = this.mapDataUsign(userSign,enterpriseSign[index],index);
                this.isTakenSideView = !userSign[0].isCreatedSide; // đã set luồng ký >> xác định Bên Lập hay Bên Nhận theo thông tin isCreatedSide của user
              } else if (this.forceShowCustomerSignInfo && enterpriseSign[index].customerType == 10000) {
                childrenItems = this.mapDataNoSign(signMetadata, enterpriseSign[index], index);
                this.isTakenSideView = true;       // chưa set luồng ký >> đó là Bên Nhận
              } else {
                childrenItems.push({
                  key: (index + 1) * 10 + 1,
                  order: '',
                  name: '',
                  showNoFlowNotification: true,
                  type: this.enumContractDetailType.DETAIL
                });
                this.isTakenSideView = true;       // chưa set luồng ký >> đó là Bên Nhận
              }
            } else {
              if(enterpriseSign[index].isSetUpSignFlow){
                const itemUserSign = userSignAll.find(x => x.id == enterpriseSign[index].contractEnterpriseId)
                childrenItems = this.mapDataUsign(itemUserSign.data, enterpriseSign[index], index,signMetadata,true); // map role ky
              }
              else {
                childrenItems = this.mapDataNoLogin(signMetadata,enterpriseSign[index],index); //
              }
              // Nếu đơn vị đã thực hiện ký qua email, không đăng nhập tài khoản hệ thống
              // childrenItems.push(children)
              this.isTakenSideView = true;       // đã ký qua link gửi về email >> đó là Bên Nhận
            }
          } else {
            childrenItems = this.mapDataNoSign(signMetadata,enterpriseSign[index],index);
          }
          const mainItem = {
            key: index + 1,
            order: enterpriseSign[index].order,
            name: enterpriseSign[index].enterpriseName,
            status: enterpriseSign[index].status,
            showNoFlowNotification: childrenItems[0].showNoFlowNotification,
            type: this.enumContractDetailType.ENTERPRISE,
            children: childrenItems,
            identityStatus: enterpriseSign[index].identityStatus ? enterpriseSign[index].identityStatus : null,
            enterpriseId: enterpriseSign[index].enterpriseId,
            identityReason: enterpriseSign[index].identityReason ? enterpriseSign[index].identityReason : null,
            customerType: enterpriseSign[index].customerType,
            customerId: enterpriseSign[index].customerId ? enterpriseSign[index].customerId : null
            // signConfig: enterpriseSign[index].signConfig ? (JSON.parse(enterpriseSign[index].signConfig).showImage ? JSON.parse(enterpriseSign[index].signConfig) : {showImage: false}) : {showImage: false}
          };
          arr.push(mainItem);
        }
      } else {
        this.isSetUpSignFlow = true
        for (let index = 0; index < enterpriseSign.length; index++) {
          let childrenItems = [];
            if (enterpriseSign[index] && enterpriseSign[index].signMetadata) {
              signMetadata = JSON.parse(enterpriseSign[index].signMetadata);
            }
            const itemUserSign = userSignAll.find(x => x.id == enterpriseSign[index].contractEnterpriseId)
            if (enterpriseSign[index].isSignedAnonymous == false || (enterpriseSign[index].isSignedAnonymous && enterpriseSign[index].isSetUpSignFlow)) {
              if (itemUserSign && itemUserSign.data.length > 0) {
                    childrenItems = this.mapDataUsign(itemUserSign.data, enterpriseSign[index], index, signMetadata);
                    this.isTakenSideView = itemUserSign.length > 0 ? !itemUserSign[0].isCreatedSide : false;
              } else {
                if (userSign && userSign.length > 0 && enterpriseSign[index].isCreatedSide ) {
                  childrenItems = this.mapDataUsign(userSign,enterpriseSign[index],index);
                  this.isTakenSideView = !userSign[0].isCreatedSide; // đã set luồng ký >> xác định Bên Lập hay Bên Nhận theo thông tin isCreatedSide của user
                } else {
                  childrenItems = this.mapDataNoSign(signMetadata, enterpriseSign[index], index);
                }
              }
            } else {
              // Nếu đơn vị đã thực hiện ký qua email, không đăng nhập tài khoản hệ thống
              childrenItems = this.mapDataNoLogin(signMetadata, enterpriseSign[index], index);
              // childrenItems.push(children)
              this.isTakenSideView = true;       // đã ký qua link gửi về email >> đó là Bên Nhận
            // }
          }

          const mainItem = {
            key: index + 1,
            order: enterpriseSign[index].order,
            name: enterpriseSign[index].enterpriseName,
            status: enterpriseSign[index].status,
            showNoFlowNotification: childrenItems[0].showNoFlowNotification,
            type: this.enumContractDetailType.ENTERPRISE,
            children: childrenItems,
            identityStatus: enterpriseSign[index].identityStatus ? enterpriseSign[index].identityStatus : null,
            enterpriseId: enterpriseSign[index].enterpriseId,
            identityReason: enterpriseSign[index].identityReason ? enterpriseSign[index].identityReason : null,
            customerType: enterpriseSign[index].customerType,
            customerId: enterpriseSign[index].customerId ? enterpriseSign[index].customerId : null
            // signConfig: enterpriseSign[index].signConfig ? (JSON.parse(enterpriseSign[index].signConfig).showImage ? JSON.parse(enterpriseSign[index].signConfig) : {showImage: false}) : {showImage: false}
          };
          arr.push(mainItem);
        }
      }
      this.mapOfExpandedData = {};
      arr.forEach(item => {
        this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
      });
      if (window.location.href.includes('view-document-moha-digital') || window.location.href.includes('waitSignMoha')) {
        this.listOfMapDataCustomer = arr.filter(item => item.customerType == 10000);
        this.listOfMapData = arr.filter(item => item.customerType != 10000);
        this.checkMohaDigital = true;
      }else{
      this.listOfMapData = arr;
      }

      // map initial list
      this.listInitial = initial;
      this.setupInitialFlowData();
    }

    if(userApproves){
      userApproves.forEach(ele =>{
        if(ele.signConfig){
          ele.signConfig = JSON.parse(ele.signConfig);
        }
      })
      this.listDataApprover = userApproves;
    }


    if (this.isNotAttestedUser) this.setUpInformationSignedData(this.document.userApproves)
      const userSignCreated = userSign.find(item => item.userId == localStorage.getItem('userId') )
      const enterpriseSignCreated = enterpriseSign.find(item => item.enterpriseId == localStorage.getItem('enterpriseId') )
      this.showIconAttachment = enterpriseSignCreated ? enterpriseSignCreated.isCreatedSide : (userSignCreated ? userSignCreated.isCreatedSide : false)
  }

  /**
   * Set Information Signed Data
   */
  private setUpInformationSignedData(userApproves: any[] = []) {
    // map data for Information Signed
    let arrSignedData = []
    userApproves.forEach((item: any, index) => {
      arrSignedData.push({
        ...item,
        key: index + 1,
        isParent: true,
        children: [
          {
            key: (index + 1) * 10 + 1,
            contact: this.convertContact(item.email, item.phone),
            email: item.email,
            status: item.status,
            time: item.processedAt ? item.processedAt : undefined,
            createdTime: item.createdTime ? item.createdTime : undefined,
            reason: item.reason,
            userPosition: item.userPosition
          }
        ]
      })
    })
    this.mapOfInformationSignedData = {};
      arrSignedData.forEach(item => {
        this.mapOfInformationSignedData[item.key] = this.convertTreeToList(item);
      });
    this.listOfInformationSignedData = arrSignedData;
    // console.log('this.mapOfInformationSignedData', this.mapOfInformationSignedData);
  }

  /**
   * Set Initial Flow.
   */
  private setupInitialFlowData() {
    if (this.listInitial) {
      const items = [];
      for (let j = 0; j < this.listInitial.length; j++) {
        items.push({
          key: (j + 1),
          order: (j + 1),
          name: this.listInitial[j].userName,
          status: this.listInitial[j].status,
          type: this.enumContractDetailType.USER,
          children: [{
            key: (j + 1) * 10 + 1,
            order: '',
            contact: this.convertContact(this.listInitial[j].userEmail, this.listInitial[j].userPhone),
            email: this.listInitial[j].userEmail,
            status: this.listInitial[j].status,
            comment: (this.listInitial[j].comment != null) ? this.listInitial[j].comment : '',
            time: (this.listInitial[j].processedAt != null) ? this.listInitial[j].processedAt : '',
            type: this.enumContractDetailType.DETAIL,
            userPosition: this.listInitial[j].userPosition
          }]
        });
      }

      this.mapOfInitialData = {};
      items.forEach(item => {
        this.mapOfInitialData[item.key] = this.convertTreeToList(item);
      });
      this.listOfMapInitialData = items;

      // console.log('this.listOfMapInitialData', this.listOfMapInitialData);
    }
  }

  /**
   * Check current viewing user is from taken side or creator side
   * @param referenceData the reference data.
   */
  private checkIsTakenSide(userSign: any) {
    // if(!this.isSetSignFlow){
    //   if(this.userSign)
    // }
  }

  /**
   * Get reference document.
   * @param referenceData the reference data.
   */
  public getDocumentRefer(referenceData) {
    this.documentReference = referenceData;
  }

  /**
   * Get servicetype by id
   */
  getServiceType(serviceTypeId) {
    this.commonService.getServiceType(serviceTypeId).subscribe(rs => {
      this.document.serviceType = rs.data.name;
    });
  }

  /**
   * Get inform service type of document type id
   * @param idDocumentType Document type id
   */
  getServiceTypeByDocumentTypeId(idDocumentType: string) {
    // this.documentTypeService.getServiceTypeByDocumentTypeId(idDocumentType).subscribe(rs => {
    //   if (rs.data) {
    //     this.document.serviceType = rs.data.name;
    //   }
    // });
  }

  downloadFile(id, name) {
    this.commonService.downloadDocumentFile(id).subscribe(rs => {
      this.downLoadFile(rs, 'application/octet-stream', name);
    });
  }

  /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   * @param fileName - file name of file
   */
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  /**
   * Lấy danh sách Người dùng sẽ ký/Duyệt Hợp đồng && Lấy danh sách các bên chủ thể sẽ Ký Hợp đồng
   */
  // getListEnterpriseUserSignByDocumentId1() {
  //   if (this.documentId) {
  //     this.documentService.getListEnterpriseUserSignBydocumentIdService(this.documentId).subscribe(rs => {
  //       if (rs.data) {
  //         let {enterpriseSign, userSign, initial} = rs.data;
  //         if (enterpriseSign && userSign) {
  //           userSign = userSign.map((item, index) => ({
  //             ...item,
  //             name: item.userName,
  //             isChild: true
  //             // key: index + 1
  //           }));
  //           enterpriseSign = enterpriseSign.map((item, index) => {
  //               let children = [];
  //               if (item.enterpriseId == this.enterpriseId) {
  //                 children = userSign.filter(el => {
  //                   return el.enterpriseId == item.enterpriseId;
  //                 });
  //                 children = children.map((el, id) => {
  //                   return {
  //                     ...el,
  //                     key: Number(`${String(index + 1)}${id + 1}`),
  //                     order: `${String(index + 1)}.${id + 1}`,
  //                   };
  //                 });
  //               } else {
  //                 children = [{
  //                   ...item,
  //                   order: `${index + 1}.1`,
  //                   key: Number(`${String(index + 1)}${1}`),
  //                 }];
  //               }

  //               const returnItem = {
  //                 order: String(index + 1),
  //                 key: index + 1,
  //                 ...item,
  //                 name: item.enterpriseName,
  //                 isChild: false,
  //                 isCurrentEnterprise: item.enterpriseId == this.enterpriseId,
  //                 children
  //               };
  //               return returnItem;
  //             }
  //           );
  //           this.mapOfExpandedData = {};
  //           console.log(enterpriseSign);
  //           enterpriseSign.forEach(item => {
  //             this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
  //           });
  //           // console.log('this.mapOfExpandedData', this.mapOfExpandedData);
  //           this.listOfMapData = enterpriseSign.sort();
  //         }
  //       }
  //     }, (error) => console.log(error));
  //   }
  // }

  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  openPopupforwardContract(user) {
    const dialogRef = this.dialog.open(ConfirmForwardComponent, {
      data: {
        receiveId: user.receiveId,
        contractId: this.document.id,
        receiveType: user.receiveType,
        receiveName: user.receiveName ? user.receiveName : user.departmentName
      },
      width: '700px'
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res === 'success') {
        const index = this.listOfDataUserForward.indexOf(user);
        this.listOfDataUserForward[index].status = 'SUCCESS';
        const allDone = this.listOfDataUserForward.filter(item => {
          return item.status !== 'SUCCESS'
        });
        if (allDone.length > 0) {
          this.isAllContractShareDone = false;
        } else {
          this.isAllContractShareDone = true;
        }
      } else {
        if (res) {
          const index = this.listOfDataUserForward.indexOf(user);
          this.listOfDataUserForward[index].errorReason = res;
        }
      }
    })
  }

  openTimestampDialog(){
    this.dialog.open(TimestampListDialogComponent, {
      width: '1000px',
      data: this.document,
    });
  }

  checkShowBlockOtpUnit() {
    let isShowBlock = false
    if (this.isNotAttestedUser) {
      // Nếu là hợp đồng KCT và trạng thái hợp đồng đang là Chờ xác nhận  => hiển thị block OTP đơn vị
      if (this.document.status === this.enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT) {
        isShowBlock = true
        // Nếu là hợp đồng KCT và trạng thái hợp đồng đang là Hoàn thành hoặc đã hủy và có danh sách người ký xác nhận
      } else if (
        this.document.status === this.enumContractStatus.FINISHED &&
        this.document.userApproves &&
        this.document.userApproves.length > 0
      ) {
        isShowBlock = true
        // Nếu là hợp đồng KCT và trạng thái hợp đồng đang là Đã hủy và không có OTP treo => Hiển thị block OTP đơn vị
      } else  if (this.document.status === this.enumContractStatus.CANCELLED && this.document.otpNotSigned === true) {
        isShowBlock = true
      }
    }
    return isShowBlock
  }

  getMessageNoteSignFlowDesign() {
    return this.message.getMessage('note_sign_flow_design').replace('{0}', "Tai khoan chu the");
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }

  copyLink(item) {
    const dest = this.listEnterpriseSign.filter($ => $.certificateNo == item.certificateNo || $.certificateNo == item.certificateNoNew)[0]
    if(!this.isIos()) {
      const customerId = this.decodeId(dest.customerId)
      const payload = {
        id: customerId,
        isCreatedSide: item.isCreatedSide,
        contractUserId: (item.role && item.role == 7) ? item.contractUserId : null
      };
      this.documentService.retrieveSignLink(this.documentId, payload).subscribe(res => {
        if(res.data) {
          if (navigator.clipboard) {
            navigator.clipboard.writeText(res.data).then(() => {
              this.toastr.success(
                this.message.getMessage("app_mobile.link_copied")
              );
            }).catch((error) => {
              console.error('Lỗi khi sao chép đường dẫn:', error);
              this.unsecuredCopyToClipboard(res.data);
            });
          } else {
            this.unsecuredCopyToClipboard(res.data);
          }
        }
      })
    } else {
      if(dest.signLink) {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(dest.signLink).then(() => {
            this.toastr.success(
              this.message.getMessage("app_mobile.link_copied")
            );
          }).catch((error) => {
            console.error('Lỗi khi sao chép đường dẫn:', error);
            this.unsecuredCopyToClipboard(dest.signLink);
          });
        } else {
          this.unsecuredCopyToClipboard(dest.signLink);
        }
      }
    }
  }

  isIos() {
    return navigator.userAgent.match(/ipad|iphone/i);
  }

  unsecuredCopyToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      // debugger
      const res = document.execCommand('copy');
      if(res) {
        this.toastr.success(
          this.message.getMessage("app_mobile.link_copied")
        );
      } else {
        console.error('Không copy được');
      }

    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
        return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  mapOfExpandData: { [key: string]: boolean } = {};


  mapDataUsign(userSign: any,enterpriseSignItem:any,index:any,signMetadataSignCustemor?:any,check?){
    let signMetadata: any;
    let childrenItems = [];
    for (let j = 0; j < userSign.length; j++) {
      if (userSign[j].signMetadata) {
        signMetadata = JSON.parse(userSign[j].signMetadata);
      }
        childrenItems.push({
          key: (index + 1) * 10 + (j + 1),
          order: enterpriseSignItem.order + '.' + (userSign[j].order != undefined ? userSign[j].order : userSign.length),
          name: userSign[j].userName,
          status: userSign[j].status,
          showNoFlowNotification: false,
          role: userSign[j].role,
          isSignDigitalCertificate: userSign[j].isSignDigitalCertificate,
          signConfig: userSign[j].signConfig ? this.setDataSignConfig(JSON.parse(userSign[j].signConfig)) : {
            resize: false,
            showImage: userSign[j].isSignDigitalCertificate ? false : (userSign[j].role + '' == EnumRoleUser.USER_SIGN ? true : false)
          },
          type: this.enumContractDetailType.USER,
          departmentName: userSign[j].departmentName,
          children: [{
            statusCe:userSign[j].role==1 ? enterpriseSignItem.status:null,
            key: ((index + 1) * 10 + (j + 1)) * 10 + 1,
            order: '',
            contact: this.convertContact(userSign[j].userEmail, userSign[j].userPhone),
            email: userSign[j].userEmail,
            status: userSign[j].status,
            comment: (userSign[j].comment != null) ? userSign[j].comment : '',
            time: (userSign[j].processedAt != null) ? userSign[j].processedAt : '',
            showNoFlowNotification: false,
            role: userSign[j].role,
            isSignDigitalCertificate: userSign[j].isSignDigitalCertificate,
            signConfig: userSign[j].signConfig ? this.setDataSignConfig(JSON.parse(userSign[j].signConfig)) : {
              resize: false,
              showImage: userSign[j].isSignDigitalCertificate ? false : (userSign[j].role + '' == EnumRoleUser.USER_SIGN ? true : false)
            },
            establishSignNoLogin: (enterpriseSignItem.isSignNoLogin && !enterpriseSignItem.isCreatedSide) ? true : false,
            type: this.enumContractDetailType.DETAIL,
            signMethod: userSign[j].signMethod,
            signMetadata: signMetadata,
            identityStatus: enterpriseSignItem.identityStatus ? enterpriseSignItem.identityStatus : null,
            enterpriseId: enterpriseSignItem.enterpriseId,
            identityReason: enterpriseSignItem.identityReason ? enterpriseSignItem.identityReason : null,
            signConfigEnterprise: {showImage: false},
            taxCode:userSign[j].taxCode,
            certificateNoNew:  enterpriseSignItem.enterpriseCertificateNo ? enterpriseSignItem.enterpriseCertificateNo : null,
            isCreatedSide: enterpriseSignItem.isCreatedSide,
            contractUserId: userSign[j].contractUserId,
            isSetUpSignFlow: enterpriseSignItem.isSetUpSignFlow,
            userPosition: userSign[j].userPosition,
            customerId: userSign[j].customerId ? userSign[j].customerId : null,
            isBuyService: userSign[j].isBuyService ? userSign[j].isBuyService : null,
          }]
        });
    }
    if(enterpriseSignItem.status == this.enumContractEnterpriseStatus.NO_PROCESS && enterpriseSignItem.isSetUpSignFlow && this.checkUSerCreateContract){
        const numberUserSign = userSign[userSign.length-1].order + 1;
        const orderUserSign = enterpriseSignItem.order + '.' + numberUserSign;
       // console.log(orderMax);
        if(check){
          childrenItems = this.datamapKH(signMetadata,enterpriseSignItem,index + 1,childrenItems,signMetadataSignCustemor,true,orderUserSign)
        }
        else{
          childrenItems = this.datamapKH(signMetadata,enterpriseSignItem,index + 1,childrenItems,signMetadataSignCustemor,false,orderUserSign)
        }
    }
    // if (childrenItems[0].children[0].isSetUpSignFlow && !childrenItems[0].children[0].isCreatedSide){
    //   const numberUserSign = userSign[userSign.length-1].order + 1;
    //   const orderUserSign = enterpriseSignItem.order + '.' + numberUserSign;
    //  // console.log(orderMax);
    //   if(check){
    //     childrenItems = this.datamapKH(signMetadata,enterpriseSignItem,index + 1,childrenItems,signMetadataSignCustemor,true,orderUserSign)
    //   }
    //   else{
    //     childrenItems = this.datamapKH(signMetadata,enterpriseSignItem,index + 1,childrenItems,signMetadataSignCustemor,false,orderUserSign)
    //   }
    //
    // }
    return childrenItems;
  }

  mapDataNoLogin(signMetadata,enterpriseSignItem,index){
    let childrenItems = [];
    childrenItems.push({
      key: (index + 1) * 10 + 1,
      order: '',
      contact: this.convertContact(enterpriseSignItem.enterpriseEmail, enterpriseSignItem.enterprisePhone),
      email: enterpriseSignItem.enterpriseEmail,
      certificateNo: enterpriseSignItem.enterpriseCertificateNo,
      status: enterpriseSignItem.status,
      comment: (enterpriseSignItem.comment != null) ? enterpriseSignItem.comment : '',
      time: (enterpriseSignItem.processedAt != null) ? enterpriseSignItem.processedAt : '',
      showNoFlowNotification: false,
      establishSignNoLogin: true,
      isSignedAnonymous: true,
      type: this.enumContractDetailType.DETAIL,
      signMethod: enterpriseSignItem.signMethod,
      signMetadata: signMetadata,
      identityStatus: enterpriseSignItem.identityStatus ? enterpriseSignItem.identityStatus : null,
      enterpriseId: enterpriseSignItem.enterpriseId,
      identityReason: enterpriseSignItem.identityReason ? enterpriseSignItem.identityReason : null,
      isCreatedSide: enterpriseSignItem.isCreatedSide,
      signConfigEnterprise: enterpriseSignItem.signConfig ? (JSON.parse(enterpriseSignItem.signConfig).showImage ? JSON.parse(enterpriseSignItem.signConfig) : {showImage: false}) : {showImage: false}
    });
    return childrenItems
  }
  mapDataNoSign(signMetadata,enterpriseSignItem,index){
    let childrenItems = [];
    childrenItems.push({
      key: (index + 1) * 10 + 1,
      order: '',
      contact:  this.convertContact(enterpriseSignItem.enterpriseEmail, enterpriseSignItem.enterprisePhone),
      email: enterpriseSignItem.enterpriseEmail,
      certificateNo: enterpriseSignItem.enterpriseCertificateNo,
      status: enterpriseSignItem.status,
      comment: (enterpriseSignItem.comment != null) ? enterpriseSignItem.comment : '',
      time: (enterpriseSignItem.processedAt != null) ? enterpriseSignItem.processedAt : '',
      showNoFlowNotification: false,
      establishSignNoLogin: (enterpriseSignItem.isSignNoLogin != null) ? enterpriseSignItem.isSignNoLogin : false,
      isSignedAnonymous: (enterpriseSignItem.isSignedAnonymous != null) ? enterpriseSignItem.isSignedAnonymous : false,
      type: this.enumContractDetailType.DETAIL,
      signMethod: enterpriseSignItem.signMethod,
      signMetadata: signMetadata,
      identityStatus: enterpriseSignItem.identityStatus ? enterpriseSignItem.identityStatus : null,
      enterpriseId: enterpriseSignItem.enterpriseId,
      identityReason: enterpriseSignItem.identityReason ? enterpriseSignItem.identityReason : null,
      isCreatedSide: enterpriseSignItem.isCreatedSide,
      signConfigEnterprise: enterpriseSignItem.signConfig ? (JSON.parse(enterpriseSignItem.signConfig).showImage ? JSON.parse(enterpriseSignItem.signConfig) : {showImage: false}) : {showImage: false},
      customerType: enterpriseSignItem.customerType,
      customerId: enterpriseSignItem.customerId ? enterpriseSignItem.customerId : null,
      isBuyService: enterpriseSignItem.isBuyService ? enterpriseSignItem.isBuyService : null,
    });
    return childrenItems
  }
  datamapKH(signMetadata,enterpriseSignItem,index,value,signMetadataSignCustemor,check?,childrenItemsLength?){
    const numberoder = ((index + 1) * 10 + (index + 1)) * 10 + 1
    value.push({
      key: (index + 1) * 10 + (index + 1),
      order:childrenItemsLength,
      name:check?enterpriseSignItem.enterpriseName: enterpriseSignItem.enterpriseName,
      status:check?enterpriseSignItem.status: enterpriseSignItem.userSignStatus,
      showNoFlowNotification: false,
      role: check?1:null,
      // isSignDigitalCertificate: userSign[j].isSignDigitalCertificate,
      type: this.enumContractDetailType.USER,
      departmentName: enterpriseSignItem.departmentName,
      isSetUpSignFlowCreatedSide: check?false:true,
      children: [{
        key: numberoder,
        order: '',
        contact: this.convertContact(enterpriseSignItem.enterpriseEmail, enterpriseSignItem.enterprisePhone),
        email: enterpriseSignItem.enterpriseEmail,
        certificateNoNew: enterpriseSignItem.enterpriseCertificateNo,
        status: enterpriseSignItem.status,
        comment: (enterpriseSignItem.comment != null) ? enterpriseSignItem.comment : '',
        time: (enterpriseSignItem.processedAt != null) ? enterpriseSignItem.processedAt : '',
        showNoFlowNotification:  false,
        establishSignNoLogin: enterpriseSignItem.status == 4 ? true : ((enterpriseSignItem.isSignNoLogin != null) ? enterpriseSignItem.isSignNoLogin : false),
        isSignedAnonymous: enterpriseSignItem.status == 4 ? true : ((enterpriseSignItem.isSignedAnonymous != null) ? enterpriseSignItem.isSignedAnonymous : false),
        type: this.enumContractDetailType.DETAIL,
        signMethod: enterpriseSignItem.signMethod,
        signMetadata:enterpriseSignItem.status == 4 ? signMetadataSignCustemor :  signMetadata,
        identityStatus: enterpriseSignItem.identityStatus ? enterpriseSignItem.identityStatus : null,
        enterpriseId: enterpriseSignItem.enterpriseId,
        identityReason: enterpriseSignItem.identityReason ? enterpriseSignItem.identityReason : null,
        isCreatedSide: enterpriseSignItem.isCreatedSide,
        signConfigEnterprise: enterpriseSignItem.signConfig ? (JSON.parse(enterpriseSignItem.signConfig).showImage ? JSON.parse(enterpriseSignItem.signConfig) : {showImage: false}) : {showImage: false},
        certificateNo: enterpriseSignItem.enterpriseCertificateNo,
      }]
    });
  return value;
  }

  undoNumberOtp(item: any) {
    this.documentService.undoOtpCustomer(item.customerId, this.documentId).subscribe(result => {
      if (result.success) {
        this.toastr.success(
          this.message.getMessage("messages.undo_otp_success")
        )
      }
    })
  }

  convertContact(email:string, phoneNumber: string) {
    let contact = '';
    if (email && phoneNumber) {
      contact = email + ' - ' + phoneNumber;
    } else if(email && !phoneNumber) {
      contact = email;
    } else if(!email && phoneNumber){
      contact = phoneNumber;
    } else {
      contact = '';
    }
    return contact;
  }

  // Start thuong thao
  messages: MessageNegotiate[] = [

  ];
  newMessage = '';
  fileList: File[] = [];
  replyId: string = '';
  replyMessageData: any = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      let isValidFile = true
      Array.from(input.files).forEach(file => {
        if(!this.validateFile(file)){
          isValidFile = false
          return
        }
      })
      if(this.fileList.length + Array.from(input.files).length > this.maxNumberFile ){
        this.toastr.error(this.message.getMessage('negotiate_contract.chat.error_number_file').replace('{0}', this.maxNumberFile.toString()))
        input.value = '';
        return
      }

      if(isValidFile) {
        let totalSize = 0;
        this.fileList.forEach(file => totalSize = totalSize + file.size)
        Array.from(input.files).forEach(file => totalSize = totalSize + file.size)
        if(totalSize < this.maxSize) {
          this.fileList = [...this.fileList, ...Array.from(input.files)];
        } else {
          this.toastr.error(this.message.getMessage('negotiate_contract.chat.error_total_size').replace('{0}', this.formatFileSize(this.maxSize)))
        }
        input.value = '';
      } else {
        input.value = '';
      }
       // Reset input file
    }
  }

  removeFile(index: number): void {
    this.fileList.splice(index, 1);
  }

  sendMessage(): void {
      if (!this.canReplyNegotiation) { this.clearReplyMessageData(); }
    if (this.newMessage.trim() || this.fileList.length > 0) {
      const dataMessage = new FormData()
      dataMessage.append('contractId', this.document.id)
      dataMessage.append('content', this.newMessage.trim())
      dataMessage.append('parentId', this.replyId)
      if (this.fileList.length > 0) {
        this.fileList.forEach(file =>{
          dataMessage.append('mFiles', file)
        })
      }
      this.newMessage = '';
      this.fileList = [];
      this.clearReplyMessageData()
      this.documentService.commitNegotiate(dataMessage).pipe(finalize(()=>{
        this.newMessage = '';
        this.fileList = [];
      })).subscribe(res => {
        console.log(res);
        this.getHistoryChat(true)
        if(!res.success){
          this.toastr.error(res.message)
        }
      })
    }
  }

  truncateFileName(name: string, maxLength = 25): string {
    if (name.length <= maxLength) return name;
    const ext = name.substring(name.lastIndexOf('.'));
    const truncated = name.substring(0, maxLength - ext.length - 3);
    return `${truncated}...${ext}`;
  }

  formatFileSize(bytes: number, decimals = 2): string {
    if (bytes == 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
    return `${size} ${sizes[i]}`;
  }

  intervalChat: any;
  getHistoryChat(isScroll: boolean = false){
    let request = this.documentService.getHistoryNegotiate(this.document.id);
    request.pipe(finalize(()=> {
      if(isScroll) {
        this.zone.onStable.pipe(take(1)).subscribe(() => {
          this.scrollToBottom();
        });
      }
    })).subscribe(res =>{
      if (res.success) {
        console.log(res.data);
        const emptyValueLabel = this.message.getMessage1('negotiate_contract.chat.empty_value');
        this.messages = (res.data || []).map(item => mapNegotiateMessage(item, emptyValueLabel));
        this.cdr.detectChanges()
      } else {
        this.toastr.error(res.message)
      }
    })
  }

  private expandedMergeHistories = new Set<string>();

  isMergeHistoryExpanded(entry: MessageNegotiate): boolean {
    return this.expandedMergeHistories.has(this.document.id + ':' + entry.id);
  }

  toggleMergeHistory(entry: MessageNegotiate): void {
    const key = this.document.id + ':' + entry.id;
    if (this.expandedMergeHistories.has(key)) {
      this.expandedMergeHistories.delete(key);
    } else {
      this.expandedMergeHistories.add(key);
    }
  }

  allowedExtensions = [
    '.pdf', '.jpg', '.jpeg', '.png', '.bmp', '.msg', '.eml',
    '.rtf', '.doc', '.docx', '.xls', '.xlsx'
  ];

  allowedMimeTypes = [
    'application/pdf',
    'image/jpeg', 'image/png', 'image/bmp',
    'application/vnd.ms-outlook', // .msg
    'message/rfc822',             // .eml
    'application/rtf',
    'application/msword',         // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.ms-excel',   // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
  ];
  maxSize: number = 10*1024*1024
  maxNumberFile: number = 10;
  validateFile(file: File): boolean {
    const fileExt = '.' + file.name.split('.').pop().toLowerCase();
    const isValidExt = this.allowedExtensions.includes(fileExt);
    const isValidType = this.allowedMimeTypes.includes(file.type);

    if ((!isValidExt || !isValidType) && !(fileExt == '.msg' && file.type == "")) {
      this.toastr.error(this.message.getMessage('negotiate_contract.chat.error_format_file') + `: ${file.name}`)
      return false;
    }
    if (file.size == 0) {
      this.toastr.error(this.message.getMessage('negotiate_contract.chat.error_no_size'))
      return false;
    }
    return true;
  }

  downLoadFileNegotiate(file: any) {
    this.documentService.downLoadFileNegotiate(file.filePath).subscribe(rs => {
      console.log(rs);
      // this.downLoadFile(rs, 'application/octet-stream', file.fileName)
      if(rs.type == 'application/json') {
        this.toastr.error(this.message.getMessage('messages.no_permission_on_document'))
        return;
      }
      let type: string = '';
      if (file.fileName.slice(-3).toLowerCase() === 'pdf') {
        type = 'pdf';
        const reader = new FileReader();
        reader.readAsDataURL(rs);
        reader.onload = (event) => {
          const path = event.target == null ? '' : (event.target as any).result;
          const filePath = path as string;
          const filePathBase64 = filePath.split(',')[1];
          this.previewPdf({filePath: file.filePath, filePathBase64: filePathBase64, fileName: file.fileName, type: type, fileId: file.id});
        }
      } else if(['png','jpg', 'bmp'].includes(file.fileName.slice(-3).toLowerCase()) || file.fileName.slice(-4).toLowerCase() == 'jpeg'){
        type = 'image'
        // const image = new Blob([rs], { type: 'image/png' });
        const imageURL = URL.createObjectURL(rs);
        this.previewPdf({type: type, fileName: file.fileName, fileId: file.id, imageURL: imageURL, filePath: file.filePath});
      } else {
        this.downLoadFile(rs, 'application/octet-stream', file.fileName)

      }

    });
  }
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChild('textAreaRef', { static: false }) textAreaRef!: ElementRef;
  isComment: boolean = true
  scrollToBottom(): void {
      if (this.scrollContainer && this.scrollContainer.nativeElement) {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
      }
  }
  onKeyDown(event: KeyboardEvent){
    if (isChatSubmitKey(event)) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  public getNegotiateCopyText = getNegotiateCopyText;

  get canReplyNegotiation(): boolean {
    return !!(this.document && this.document.status === EnumContractStatus.DRAFT && this.isComment);
  }

  replyMessage(messageInfo: any){
    if (!this.canReplyNegotiation) { return; }
    this.replyId = messageInfo.id
    this.replyMessageData = messageInfo
  }

  clearReplyMessageData(){
    this.replyId = ""
    this.replyMessageData = null
  }
  previewPdf(dataFile: any) {
    const data = {
      ...dataFile
    };
    this.isShowReferencePdf.next(true)
    const dialogRef = this.dialog.open(ViewFilePdfImgComponent, {
      width: '1000px',
      data,
      minWidth: '365px'
    });
    dialogRef.afterClosed().subscribe(rs => {
      this.isShowReferencePdf.next(false)
    });
  }
  scrollToMessage(data){
    if (data.id) {
      const element = document.getElementById(`message-id-${data.id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.classList.add('focused');
        setTimeout(() => {
          element.classList.remove('focused');
        }, 1000);
      }
    } else {
      alert('Không tìm thấy tin nhắn!');
    }
  }
  getTailFile(name: string){
    return name.split('.').pop()
  }
  copyMessage(text){
    navigator.clipboard.writeText(text)
  }
  isHover: any = null
  isActive: any = null
  // End thuong thao

  checkPermissionLimitedViewContract() {
    const permissions = localStorage.getItem('permissions');
    if(this.commonService.checkDefaultAdmin() || localStorage.getItem('userType') == '1' || localStorage.getItem('userType') == '3') {
      return true;
    }
    if(permissions.includes('13')) {
      return true;
    }
    return false;
  }

  goToContractLiquidated(id){
    const url = this.route.serializeUrl(
      this.route.createUrlTree(['/home-enterprise/view-document-moha/' + id],  {queryParams: {goFrom: this.goFrom, isOnlyView: true}})
    );
    window.open(url, '_blank')
  }

  redirectDetailContract(id: string) {
    this.route.navigate([`/home-enterprise/view-document-moha/${id}`]);
  }

  openPDFByBrowser() {
    this.documentMohaService.downloadFileEvidentXML(this.documentId).subscribe(res => {
      const nameFileCer = `CERTIFICATION_Viettel_${this.document.code}_1.xml`
      this.downLoadFile(res, 'application/octet-stream', nameFileCer);
    });
  }
}
